import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

import { onSuccessCreateRole } from "./helpers";

const createRole = async (data: CreateRoleReqT) =>
  axios.post(Routes.CREATE_ROLE, data);

export const useCreateRole = () =>
  useMutation({
    mutationKey: [Keys.CREATE_ROLE_MUT],
    mutationFn: createRole,
    onSuccess: onSuccessCreateRole,
    cacheTime: Infinity,
  });
